
import React, {FC, useState} from 'react';
import {Dropdown} from 'react-bootstrap';
import DropdownMenu from 'react-bootstrap/esm/DropdownMenu';

import * as styles from './styles.module.scss';

type Result = {
	start: {
		full: string
	}
};

type SelectorProps = {
	results: Result[],
	onSelect: (index: number) => void,
}

const Selector: FC<SelectorProps> = ({results, onSelect}) => {
	const [index, setIndex] = useState(0);
	const render = (r: Result, button: boolean) => {
		if (!button) {
			return r.start.full;
		}

		const short = r.start.full.split(' at ')[0];
		return (
			<>
				<span>{r.start.full}</span>
				<span>{short}</span>
			</>
		);
	};

	const handleSelect = (key: string | null) => {
		setIndex(Number(key));
		onSelect(Number(key));
	};

	return (
		<Dropdown className={styles.dropdown} onSelect={handleSelect}>
			<Dropdown.Toggle>
				{render(results[index], true)}
			</Dropdown.Toggle>
			<DropdownMenu>
				{results.map((r, i) => (
					<Dropdown.Item eventKey={i} key={i}>
						{render(r, false)}
					</Dropdown.Item>
				))}
			</DropdownMenu>
		</Dropdown>
	);
};

export default Selector;
